/**
 * Assistants feature service layer — agents, competitors, scopes, chat streaming.
 *
 * UI pages should import from here rather than calling assistant HTTP directly.
 */

import { AssistantsEndpoints, assistantsFetch, assistantsFetchJson } from './assistantsApiClient';
import * as agentsService from './assistantsAgentsService';
import * as chatService from './assistantsChatService';
import * as competitorsService from './assistantsCompetitorsService';
import * as scopesService from './assistantsScopesService';

export { AssistantsEndpoints, assistantsFetch, assistantsFetchJson };

export { getAgents } from './assistantsAgentsService';

export { getCompetitors } from './assistantsCompetitorsService';

export { getReferenceUrlScopes } from './assistantsScopesService';

export {
  isCuratedAssistantPayload,
  buildChatStreamRequest,
  streamAssistantChat,
} from './assistantsChatService';

/** Facade for dependency injection and testing. */
export const assistantsService = {
  endpoints: AssistantsEndpoints,
  agents: {
    list: agentsService.getAgents,
  },
  competitors: {
    list: competitorsService.getCompetitors,
  },
  scopes: {
    list: scopesService.getReferenceUrlScopes,
  },
  chat: {
    isCuratedPayload: chatService.isCuratedAssistantPayload,
    buildStreamRequest: chatService.buildChatStreamRequest,
    stream: chatService.streamAssistantChat,
  },
};
